<template>
	<b-form ref="form" @submit.prevent="add">
		<b-row class="mt-3">
			<b-col cols="6">
				<b-form-group label="Type" for="job-type">
					<b-form-select
                    required
						id="job-type"
						v-model="job.Type"
						value-field="Value"
						text-field="DisplayName"
						:options="jobTypes"
						><template #first>
							<b-form-select-option :value="null"
								>Choose type</b-form-select-option
							>
						</template></b-form-select
					>
				</b-form-group>
			</b-col>

			<b-col cols="12">
				<b-form-group label="Contact">
					<b-form-select
						required
						v-model="job.ContactId"
						value-field="Id"
						text-field="Name"
						:options="clock.Contacts"
						><template #first>
							<b-form-select-option :value="null"
								>Choose contact</b-form-select-option
							>
						</template></b-form-select
					>
				</b-form-group>
			</b-col>

			<b-col cols="12">
				<b-form-group label="Details" for="job-details" class="mb-4">
					<b-form-textarea
                        required
						id="job-details"
						placeholder="Please describe job"
						v-model="job.Details"
					></b-form-textarea>
				</b-form-group>
			</b-col>

			<b-col cols="12">
				<b-button type="submit" variant="info"> Add Job </b-button>
			</b-col>
		</b-row>
	</b-form>
</template>


<script>
import JobService from "@/api-services/job.service";

export default {
	name: "AddJobToCLock",

	// things we want to use
	components: {},

	// things we have inherited from our parent
	props: ["clock"],

	created() {
		this.fetchJobTypes();
	},

	// data we bind to, components need a function wrapping this all up, to keep instances seperate
	data: function () {
		return {
			jobTypes: [],

			job: {
				ClockId: this.clock.Id,
				ContactId: null,
				Type: null,
				Details: null,
			},
		};
	},

	// things we do to data
	methods: {
		add() {
			JobService.create(this.job)
				.then((response) => {
					this.$emit("addJob", response.data);
				})
				.catch((error) => {
					console.log(error);
				});
		},

		fetchJobTypes() {
			JobService.getEnum("jobtype")
				.then((response) => {
					this.jobTypes = response.data;
				})
				.catch((error) => {
					console.log("not authorized");
				});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/partials/add-job.vue